<template>
  <v-card-clickable class="project-preview d-flex flex-column">
    <div class="project-preview-menubar bg-lightgrey nobr" @click.prevent>
      <project-category :category="project.category" slider class="mx-1"></project-category>
      <v-spacer></v-spacer>
      <slot name="notifications"></slot>
      <slot name="menu"></slot>
    </div>
    <div class="project-preview-thumbnailbox">
      <img :src="thumbnailUrl" :class="{ 'project-preview-thumbnail-cover': thumbnailIsProjectSnapshot }" @error="thumbnailUrl = defaultBg">
    </div>
    <div class="project-preview-textbox">
      <div class="font-weight-bold">{{ project.title || $t('PLANNING.UNNAMED_PROJECT') }}</div>
      <slot name="body-details"></slot>
    </div>
  </v-card-clickable>
</template>

<style lang="scss">
  .project-preview {
    height: 100%;
  }

  .project-preview-thumbnailbox {
    height: 138px;
    flex-grow: 1;
    text-align: center;

    > img {
      object-fit: contain;
      height: 100%;
      width: 100%;

      &.project-preview-thumbnail-cover {
        object-fit: cover;
        object-position: 0 0;
      }
    }
  }

  .project-preview-menubar {
    display: flex;
    cursor: default;
  }

  .project-preview-textbox {
    position: relative;
    padding: 8px;
    background: rgb(var(--v-theme-surface));
  }
</style>

<script>
  import ProjectCategory from './ProjectCategory';

  import defaultBg from '@/img/project_default_bg.jpg';
  import defaultViewBg from '@/img/view_bg.svg';

  export default {
    components: {
      ProjectCategory,
    },
    props: {
      project: { type: Object, required: true },
      view: { type: Boolean, default: false },
    },
    data() {
      return {
        thumbnailUrl: this.view ? defaultViewBg : this.project.imgurl,
        defaultBg,
      };
    },
    computed: {
      thumbnailIsProjectSnapshot() {
        return this.thumbnailUrl.startsWith(window.apiSrv.snapBaseUrl) || this.thumbnailUrl == defaultBg || this.thumbnailUrl == defaultViewBg;
      },
    },
  };
</script>
